import React from 'react';
import { Typography, Box, BoxProps, Grid } from '@mui/material';

interface IErrorBox extends BoxProps {
  message?: string;
  showCorporateContact?: boolean;
}

const ErrorBox = (props: IErrorBox) => {
  return (
    <Box {...props}>
      <Grid container direction="column" spacing={2} style={{ padding: '5px' }}>
        <Grid item>
          <Typography variant="h5" align="center">
            {props.message ?? "Oops we couldn't load required data."}
          </Typography>
        </Grid>
        {props.showCorporateContact && (
          <>
            <Grid item>
              <Typography variant="h6" align="center">
                Please try again and contact{' '}
                <a
                  style={{ textDecoration: 'none' }}
                  rel="noopener"
                  href="https://blackboard.my.site.com/Support/s/case-type-selector?language=en_US"
                  target="_blank"
                >
                  Anthology Support
                </a>{' '}
                if the problem persists.
              </Typography>
            </Grid>
            <Grid item>
              <Typography align="center">716.270.0000</Typography>
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

export default ErrorBox;
